import React, { useState } from 'react';
import GoalNutritionAdd from './GoalNutritionAdd';

const GoalNutrition = ({ goal, setFieldValue, errors, values, validateField, setFieldTouched }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [previous, setPrevious] = useState();

  return (
    <div className="goal-block goal-block-nutrition">
      <div className="goal-icon">
        <i className="fas fa-carrot"></i>
        <label>Nutrition</label>
      </div>
      <div className="goal-info">
        <p></p>
        <p>{ goal.calories ? `${goal.calories} calories total/Day` : ''  }</p>
        <p>{ goal.carbs ? `${goal.carbs} g Carbs/Day` : ''  }</p>
        <p>{ goal.fat ? `${goal.fat} g Fats/Day` : ''  }</p>
        <p>{ goal.protein ? `${goal.protein} g Protein/Day` : ''  }</p>
        <p>{ goal.water ? `${goal.water} L Water/Day` : ''  }</p>
      </div>
      <a
        href="javascript:;"
        className="edit-goal"
        onClick={() => {
            setModalOpen(true)
            setPrevious({ ...goal })
          }
        }
        type="button"
      >
        <i className="fas fa-pen"></i>
      </a>
      <GoalNutritionAdd
        openModal={modalOpen}
        setModalOpen={setModalOpen}
        setFieldValue={setFieldValue}
        goal={previous}
        errors={errors}
        values={values}
        setFieldTouched={setFieldTouched}
      />
    </div>
  );
};

export default GoalNutrition;
